import { render, staticRenderFns } from "./IntroduceOtherParcoursCarousel.vue?vue&type=template&id=3ea8f1ec&scoped=true&"
import script from "./IntroduceOtherParcoursCarousel.vue?vue&type=script&lang=js&"
export * from "./IntroduceOtherParcoursCarousel.vue?vue&type=script&lang=js&"
import style0 from "./IntroduceOtherParcoursCarousel.vue?vue&type=style&index=0&id=3ea8f1ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea8f1ec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCarousel } from 'vuetify/lib/components/VCarousel';
installComponents(component, {VBtn,VCard,VCarousel})
